import { Check, ChevronsUpDown } from 'lucide-react'
import { useEffect, useState } from 'react'
import { cn } from '../../../../lib/utils'
import { Button } from '../../../components/ui/button'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../../components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/ui/popover'
import { useToast } from '../../../hooks'
import { loadServices } from './actions/load-services'

interface TabServicesProps {
  setServiceSelected: (service?: any) => void
  defaultService?: any
  valueWatcher?: any
}

export function TabServices({ setServiceSelected, defaultService, valueWatcher }: TabServicesProps) {
  const { showToast } = useToast()
  const { data: services } = loadServices()
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState(() => defaultService || '')

  useEffect(() => {
    if (services) {
      const data = services?.find((item) => item.id == value)
      if (data) {
        setValue(data.value)
      }
    }
  }, [services])

  const addInCart = () => {
    const data = services?.find((item) => item.id == value)
    if (data) {
      setServiceSelected(data)
      showToast('Serviço adicionado ao carrinho', 'success')
    }
  }

  useEffect(() => {
    if (valueWatcher) {
      setValue('')
    }
  }, [valueWatcher])

  return (
    <div className="w-full">
      <label className="font-semibold">Serviços</label>
      <div className="flex gap-2">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between">
              {value ? services?.find((item) => item.value === value)?.label : 'Selecione...'}
              <ChevronsUpDown className="opacity-50" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="min-w-full p-0">
            <Command>
              <CommandInput placeholder="Pesquisar..." className="h-9" />
              <CommandList>
                <CommandEmpty>Não encontrado.</CommandEmpty>
                <CommandGroup>
                  {services &&
                    services.map((item) => (
                      <CommandItem
                        key={item.value}
                        value={item.value}
                        keywords={[item.label]}
                        onSelect={(currentValue) => {
                          setValue(currentValue === value ? '' : currentValue)
                          setOpen(false)
                        }}
                      >
                        {item.label}
                        <Check className={cn('ml-auto', value === item.value ? 'opacity-100' : 'opacity-0')} />
                      </CommandItem>
                    ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
        <Button className="bg-acelerafit-green-400 text-muted hover:bg-cashfit-green-200" onClick={addInCart}>
          Adicionar ao carrinho
        </Button>
      </div>
    </div>
  )
}
